import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  IconButton,
  Center,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  VStack,
  HStack,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  Text,
  ModalFooter,
  Tooltip,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  addJobDepartmentAsync,
  deleteJobDepartmentAsync,
  fetchJobDepartmentsAsync,
  selectJobDepartments,
  updateJobDepartmentAsync,
} from "../../../JobPostingSlice/JobDepartment/JobDepartmentSlice";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";

function JobDepartments() {
  const dispatch = useDispatch();
  const jobDepartments = useSelector(selectJobDepartments);

  useEffect(() => {
    dispatch(fetchJobDepartmentsAsync());
  }, []);

  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const [newJobDepartment, setNewJobDepartment] = useState("");
  const [newJobStatus, setNewJobStatus] = useState(""); // Add status state
  const [error, setError] = useState(null);
  const [editJobDepartment, setEditJobDepartment] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editJobStatus, setEditJobStatus] = useState("");
  const [editableJobDepartment, setEditableJobDepartment] = useState(null);
  const [deletingDepartment, setDeletingDepartment] = useState(null);

  useEffect(() => {
    dispatch(fetchJobDepartmentsAsync());
  }, [dispatch]);

  const handleDelete = async (uuid) => {
    await dispatch(deleteJobDepartmentAsync(uuid));
    dispatch(fetchJobDepartmentsAsync());
    onClose2();
  };

  const openDeleteModal = (job) => {
    setDeletingDepartment(job);
    dispatch(fetchJobDepartmentsAsync());
    onOpen2();
  };

  const handleSave = async () => {
    const jobDepartment = {
      title: newJobDepartment,
      status: "active", // Get status from input
    };

    try {
      await dispatch(addJobDepartmentAsync(jobDepartment));

      dispatch(fetchJobDepartmentsAsync());
      setNewJobDepartment(""); // Clear input field after saving
      setNewJobStatus(""); // Clear status field
      onClose1();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleEdit = (jobDepartment) => {
    setEditableJobDepartment(jobDepartment);
    setEditJobDepartment(jobDepartment.title);
    setEditJobStatus(jobDepartment.status);
    setIsEditModalOpen(true);
  };

  const handleUpdate = async () => {
    if (editJobDepartment.trim()) {
      try {
        await dispatch(
          updateJobDepartmentAsync({
            uuid: editableJobDepartment.uuid,
            jobDepartmentData: {
              title: editJobDepartment,
              status: editJobStatus, // Include status
            },
          })
        );

        await dispatch(fetchJobDepartmentsAsync());
        setEditableJobDepartment(null);
        setEditJobDepartment("");
        setEditJobStatus(""); // Reset status
        setIsEditModalOpen(false);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  return (
    <div
      className="min-h-screen bg-adminbg p-4 contentAdmin"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="">
        <div className="w-full my-5 bg-white rounded-md">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Job Department List
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen1}
              >
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1} size="4xl">
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Add Job Department
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSave();
                    }}
                  >
                    <ModalBody py={6}>
                      <VStack spacing={6}>
                        <Grid
                          templateColumns="repeat(2, 1fr)"
                          gap={4}
                          width="100%"
                        >
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Department</FormLabel>
                              <Input
                                className=" "
                                color="black"
                                placeholder="Enter job department"
                                value={newJobDepartment}
                                onChange={(e) =>
                                  setNewJobDepartment(e.target.value)
                                }
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Status</FormLabel>
                              <Input
                                className=" "
                                color="black"
                                placeholder="Enter job status"
                                value={newJobStatus}
                                onChange={(e) =>
                                  setNewJobStatus(e.target.value)
                                }
                              />
                            </FormControl>
                          </GridItem>
                        </Grid>
                        {error && <Text color="red.500">{error}</Text>}
                      </VStack>
                    </ModalBody>
                    <ModalFooter bg="gray.50" borderBottomRadius="md">
                      <Button colorScheme="blue" mr={3} type="submit">
                        Save
                      </Button>
                      <Button onClick={onClose1}>Cancel</Button>
                    </ModalFooter>
                  </form>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                size="4xl"
              >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bg="blue.500" color="white" borderTopRadius="md">
                    Edit Job Department
                  </ModalHeader>
                  <ModalCloseButton color="white" />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleUpdate();
                    }}
                  >
                    <ModalBody py={6}>
                      <VStack spacing={6}>
                        <Grid
                          templateColumns="repeat(2, 1fr)"
                          gap={4}
                          width="100%"
                        >
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Department</FormLabel>
                              <Input
                                className=" "
                                color="black"
                                placeholder="Enter job title"
                                value={editJobDepartment}
                                onChange={(e) =>
                                  setEditJobDepartment(e.target.value)
                                }
                              />
                            </FormControl>
                          </GridItem>
                          <GridItem colSpan={2}>
                            <FormControl>
                              <FormLabel>Job Status</FormLabel>
                              <Input
                                className=" "
                                color="black"
                                placeholder="Enter job status"
                                value={editJobStatus}
                                onChange={(e) =>
                                  setEditJobStatus(e.target.value)
                                }
                              />
                            </FormControl>
                          </GridItem>
                        </Grid>
                        {error && <Text color="red.500">{error}</Text>}
                      </VStack>
                    </ModalBody>
                    <ModalFooter bg="gray.50" borderBottomRadius="md">
                      <Button colorScheme="blue" mr={3} type="submit">
                        Update
                      </Button>
                      <Button onClick={() => setIsEditModalOpen(false)}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </form>
                </ModalContent>
              </Modal>
              <Modal isOpen={isOpen2} onClose={onClose2}>
                <ModalOverlay />
                <ModalContent maxW="2xl" borderradius="lg" boxShadow="lg">
                  <ModalHeader
                    fontSize="lg"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Confirm Deletion
                  </ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                    <Text fontSize="md" textAlign="center">
                      Are you sure you want to delete{" "}
                      <Text as="span" fontWeight="semibold" color="red.500">
                        "{deletingDepartment?.title}"
                      </Text>
                      ?
                    </Text>
                  </ModalBody>
                  <ModalFooter display="flex" gap="2" justifyContent="center">
                    <Button
                      colorScheme="red"
                      w="40"
                      onClick={() => handleDelete(deletingDepartment.uuid)}
                    >
                      Delete
                    </Button>
                    <Button
                      variant="outline"
                      colorScheme="red"
                      w="40"
                      onClick={onClose2}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </div>
          </div>

          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/4">uuid</Th>
                  <Th className="w-1/4">Title</Th>
                  <Th className="w-1/4">Status</Th>
                  <Th className="w-1/4">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {Array.isArray(jobDepartments) && jobDepartments.length > 0 ? (
                  [...jobDepartments]
                    .sort((a, b) => a.uuid.localeCompare(b.uuid))
                    .map((job, index) => (
                      <Tr key={job.uuid}>
                        <Td>{index + 1}</Td>
                        <Td>{job.title}</Td>
                        <Td textColor={"green"} className="capitalize">{job.status}</Td>
                        <Td>
                          <HStack spacing={2}>
                            <Tooltip label="Edit Department" placement="top">
                              <IconButton
                                icon={<EditIcon />}
                                colorScheme="blue"
                                size="sm"
                                onClick={() => handleEdit(job)}
                                aria-label="Edit department"
                              />
                            </Tooltip>
                            <Tooltip label="Delete Department" placement="top">
                              <IconButton
                                icon={<DeleteIcon />}
                                colorScheme="red"
                                size="sm"
                                onClick={() => openDeleteModal(job)}
                                aria-label="Delete department"
                              />
                            </Tooltip>
                          </HStack>
                        </Td>
                      </Tr>
                    ))
                ) : (
                  <div>No data found</div>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default JobDepartments;
